import { render } from "./Button.vue?vue&type=template&id=5b88188a&scoped=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=5b88188a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5b88188a"

export default script